import { render } from "./CreateUser.vue?vue&type=template&id=321aa26c&scoped=true"
import script from "./CreateUser.vue?vue&type=script&lang=js"
export * from "./CreateUser.vue?vue&type=script&lang=js"

import "./CreateUser.vue?vue&type=style&index=0&id=321aa26c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321aa26c"]])

export default __exports__